"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { promoFromSearch, writePromoLink } from "@aluume/shared/lib/promo-link";

/** Renders nothing — stores a ?promo=CODE from ANY page so it applies to whatever the guest books
 *  next (see lib/promo-link.ts). Re-runs on client navigation, so a later link with a different
 *  code replaces the earlier one. */
export function PromoLinkCapture() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  useEffect(() => {
    const code = promoFromSearch(searchParams.toString());
    if (!code) return;
    try { writePromoLink(window.localStorage, code); } catch { /* private mode */ }
  }, [pathname, searchParams]);
  return null;
}
